import React from 'react';
// import { Link } from 'react-router-dom';

function Button(props) {
  return (
    <a href={props.to}>
      <button
        className={`${
          props.white
            ? 'bg-gray-50 text-blue-900 hover:bg-blue-700 hover:text-gray-50'
            : 'text-gray-50 bg-blue-900 hover:bg-blue-700'
        } active:bg-gray-900 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-2 ease-linear transition-all duration-150`}
      >
        {/* <Link
        to={props.to}
      >
        {props.children}
      </Link> */}
        {props.children}
      </button>
    </a>
  );
}

export default Button;
